export const FETCH_TRANSACTION_LIST = 'transactions/FETCH_TRANSACTION_LIST';
export const FETCH_TRANSACTION_LIST_SUCCESS = 'transactions/FETCH_TRANSACTION_LIST_SUCCESS';

export const FETCH_TRANSACTION = 'transactions/FETCH_TRANSACTION';
export const FETCH_TRANSACTION_SUCCESS = 'transactions/FETCH_TRANSACTION_SUCCESS';
